var calculateRoyalties = function calculateRoyalties(numberOfStreams, store) {
  var royalties = Math.round(numberOfStreams * store.rate * 100) / 100;
  return royalties.toFixed(2);
};

export { calculateRoyalties };